import { Action, createReducer, on } from '@ngrx/store';
import { IScanDocumentData } from '@partners/api';
import { StateBuilder } from '../../../model/state.builder';
import { ScanActions } from './scan.actions';
import { IScanDocumentState } from './scan.state';

export const initialScanDocumentState: IScanDocumentState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};
export const initialUploadDocumentData: IScanDocumentData = {
  isBiometric: undefined,
  isFrontScanned: undefined,
  isBackScanned: undefined,
  isMaxAttemptsExceeded: undefined,
  croppedImage: undefined,
  backSideDocumentImage: undefined,
  frontSideDocumentImage: undefined
};

const scanDocumentReducerFn = createReducer(
  initialScanDocumentState,
  on(ScanActions.resetScanDocument, (state: IScanDocumentState, action) => {
    return new StateBuilder<IScanDocumentState>(initialScanDocumentState).build();
  }),
  //mainly for saving the selected document code to scan
  on(ScanActions.loadScanDocument, (state: IScanDocumentState, action) => {
    const { selectedDocId } = action;
    const completeModel = {
      ...state,
      model: { ...state.model, selectedDocId }
    };

    return new StateBuilder<IScanDocumentState>(state, { ...completeModel }).toLoaded().build();
  }),
  //save all models for scanDocument, scanDetails and saveDocument http calls
  on(ScanActions.submitScanDocument, (state: IScanDocumentState, action) => {
    const completeModel = {
      ...state,
      model: { ...state.model, ...action.model }
    };

    return new StateBuilder<IScanDocumentState>(state, { ...completeModel }).toLoaded().build();
  }),
  //save all responses of scanDocument, scanDetails and saveDocument http calls
  on(ScanActions.submitScanDocumentSuccess, (state: IScanDocumentState, action) => {
    const completeData = {
      ...state,
      data: { ...state.data, ...action.data }
    };

    return new StateBuilder<IScanDocumentState>(state, { ...completeData }).toLoaded().build();
  }),

  on(ScanActions.saveScanValidate, (state: IScanDocumentState, action) => {
    const completeData = {
      ...state,
      data: { ...state.data, validate: action.data }
    };

    return new StateBuilder<IScanDocumentState>(state, { ...completeData }).toLoaded().build();
  }),

  on(ScanActions.submitScanDocumentFailure, (state: IScanDocumentState, error) => {
    return new StateBuilder<IScanDocumentState>(state).toError(error).build();
  }),
  on(ScanActions.scanValidateFailure, (state: IScanDocumentState, error) => {
    return new StateBuilder<IScanDocumentState>(state).toError(error).build();
  }),
  on(ScanActions.updateMaxAttemptsError, (state: IScanDocumentState, action) => {
    const { isMaxAttemptsExceeded } = action;
    const completeData = {
      ...state,
      data: { ...state.data, isMaxAttemptsExceeded }
    };
    return new StateBuilder<IScanDocumentState>(state, { ...completeData }).toLoaded().build();
  }),

  on(ScanActions.loadScanIntroSuccess, (state: IScanDocumentState, action) => {
    return new StateBuilder<IScanDocumentState>(state, action).toLoaded().build();
  }),
  on(ScanActions.loadScanMethodSuccess, (state: IScanDocumentState, action) => {
    const scanMethod = {
      ...state,
      data: { ...state.data, ...action.data }
    };
    return new StateBuilder<IScanDocumentState>(state, { ...scanMethod }).toLoaded().build();
  }),
  on(ScanActions.uploadDocument, (state: IScanDocumentState, action) => {
    const uploadDocument = {
      ...state,
      model: { ...state.model, ...action.model }
    };
    return new StateBuilder<IScanDocumentState>(state, { ...uploadDocument }).toLoaded().build();
  }),
  on(ScanActions.uploadDocumentSuccess, (state: IScanDocumentState, action) => {
    const uploadDocument = {
      ...state,
      data: { ...state.data, ...action.data }
    };
    return new StateBuilder<IScanDocumentState>(state, { ...uploadDocument }).toLoaded().build();
  }),
  on(ScanActions.deleteDocument, (state: IScanDocumentState) => {
    const updatedData = {
      ...state.data,
      documents: state.data.documents.filter((doc) => doc.docCode !== state.model.selectedDocId)
    };
    return new StateBuilder<IScanDocumentState>(state, { ...updatedData }).toLoaded().build();
  }),
  on(ScanActions.deleteBackSideDocument, (state: IScanDocumentState) => {
    state.data.backSideDocumentImage = undefined;
    return new StateBuilder<IScanDocumentState>(state, { ...state.data }).toLoaded().build();
  }),
  on(ScanActions.deleteFrontSideDocument, (state: IScanDocumentState) => {
    state.data.frontSideDocumentImage = undefined;
    return new StateBuilder<IScanDocumentState>(state, { ...state.data }).toLoaded().build();
  }),

  on(ScanActions.resetUploadedDocuments, (state: IScanDocumentState) => {
    const uploadDocument = {
      ...state,
      data: { ...state.data, ...initialUploadDocumentData }
    };
    return new StateBuilder<IScanDocumentState>(state, { ...uploadDocument }).toLoaded().build();
  }),
  on(ScanActions.updateLastScanAction, (state: IScanDocumentState, action) => {
    const { lastScanAction } = action;
    const completeData = {
      ...state,
      data: { ...state.data, lastScanAction }
    };
    return new StateBuilder<IScanDocumentState>(state, completeData).toLoaded().build();
  })
);

export function scanDocumentReducer(state: IScanDocumentState | undefined, action: Action) {
  return scanDocumentReducerFn(state, action);
}
